import axios from '@/utils/axios'
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        payment: null,
        payments: [],
    },
    mutations: {
        setPayment(state, payload) {
            state.payment = payload;
        },
        setPayments(state, payload) {
            state.payments = payload;
        }
    }, 
    actions: {
        storePayment({rootState, dispatch}, payload) {
            const headers = {
                Authorization: `Bearer ${rootState.authentication.token}`,
                Dpk: payload.dpk
            }
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url:`${rootState.sales.routePrefix}/payments`,
                    data: payload,
                    headers: headers
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })
            })
        },
        updatePayment({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `${rootState.sales.routePrefix}/payments/${payload.id}`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removePayment({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.sales.routePrefix}/payments/${payload.id}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        removePayments({rootState, dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `${rootState.sales.routePrefix}/payments`,
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error);
                })

            })
        },
        fetchPayment({ commit, rootState, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.sales.routePrefix}/payments/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setPayment', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        },
        fetchPayments({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.sales.routePrefix}/payments?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setPayments', response.data.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                } 
                );
            })
        }

    }
}